import GetTopDistance from "../utilities/GetTopDistance.js";
import Window from "../stores/Window.js";

export default class Anchor {
  constructor(options) {
    this.$el = options.$el;
    this.$el.addEventListener("click", this.onAnchorClick.bind(this));
  }

  onAnchorClick() {
    const anchor = document.querySelector(
      `*[data-anchor-to="${this.$el.getAttribute("data-anchor")}"]`
    );
    if (isNaN(anchor)) {
      const menuHeight = 190;
      window.scrollTo({
        top: GetTopDistance(anchor) - menuHeight,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/global/Anchor.js